// 🚨 AUTO-GENERADO desde ReceivedInvoiceDataType.ts - No editar manualmente

export const ReceivedInvoiceFormDataKeys = [
  "id",
  "receivedEmailId",
  "xmlInvoiceAttachmentId",
  "xmlResponseAttachmentId",
  "pdfAttachmentId",
  "emisorIdentificacion",
  "emisorNombre",
  "receptorIdentificacion",
  "receptorNombre",
  "clave",
  "sequence",
  "fecha",
  "currency",
  "subtotal",
  "descuento",
  "impuestos",
  "total",
  "status",
  "errorMessage",
  "documentStatus",
  "providerId",
  "reference_number",
  "documentType",
  "documentNoteType",
  "documentId"
] as const;
